import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "350",
  "slug": "spot-mongolia-from-satellite-imagery",
  "title": "How to Recognise Mongolia in Satellite Images",
  "excerpt": "A broad regional view shows open steppe grading into the drier Gobi in the south, with mountain ranges in the west and forested areas in the north.",
  "date": "2026-06-04",
  "category": "Geography",
  "image": "/blog-images/mongolia.jpg",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "A broad regional view shows open steppe grading into the drier Gobi in the south, with mountain ranges in the west and forested areas in the north. The Gobi extends into China; it includes extensive stony terrain as well as dunes."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Compare the positions of mountain ranges, lakes, and dry basins before using sparse settlement as a clue. Open grassland and unpaved tracks also occur in neighbouring Russia and China. At a closer scale, trace a valley or railway to a mapped settlement. The absence of fields in a small crop is weak evidence, especially when snow hides the ground."
    }
  ],
  "imageAlt": "Mongolia regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
